// core version + navigation, pagination modules:
import Swiper, { FreeMode, EffectFade, Scrollbar, Autoplay } from 'swiper';
// import Swiper and modules styles
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';	

function teaserSlider() {
    
  const swiperMobile = new Swiper('.teaser-slider', {

      modules: [FreeMode, Scrollbar, EffectFade],
      loop: false,
      slidesPerView: 1,
      // effect: 'fade',
      spaceBetween: 15,
      // draggable: true,
      // allowTouchMove: true,
      freeMode: {
        enabled: true,
        sticky: false,
        momentum: true,
        momentumRatio: 0.6,
        momentumVelocityRatio: 0.6,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
  });

  const swiperDesktop = new Swiper('.js-teaser-slider-desktop ', {
    
    modules: [Autoplay, EffectFade],
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 15,
    autoplay: {
      delay: 4500,
    },
    speed: 700,
    effect: 'fade',
  });
  swiperDesktop.on('realIndexChange', function () {
    console.log('slide changed');
    document.querySelector('.link-0').classList.remove('active');
    document.querySelector('.link-1').classList.remove('active');
    document.querySelector('.link-2').classList.remove('active');
    document.querySelector('.link-' + swiperDesktop.realIndex).classList.add('active');
  });
    
}

export default teaserSlider;